import { Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';

import { GetStartedContractorFragment, GetStartedOrganizationFragment } from 'types';

import GetStartedList from './GetStartedList';

type Props = {
  openSidebar: () => void;
  contractor: GetStartedContractorFragment;
  organization: GetStartedOrganizationFragment;
};

const SidebarContainer = styled(Box, {
  name: 'SidebarContainer',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.common.purple100,
  width: '400px',
  height: '100%',
}));

const SidebarHeader = styled(Box, {
  name: 'SidebarHeader',
})({
  width: '100%',
  height: '70px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  columnGap: '20%',
  marginTop: 4,
  marginRight: 36,
});

const GetStartedSidebar = ({
  openSidebar,
  contractor,
  organization,
}: Props): JSX.Element => (
  <SidebarContainer data-testid="get-started-sidebar">
    <SidebarHeader>
      <Typography variant="h3">
        Get Started
      </Typography>
      <IconButton
        onClick={openSidebar}
        aria-label="collapse sidebar icon"
        data-testid="collapse-sidebar-icon"
      >
        <CloseFullscreenRoundedIcon />
      </IconButton>
    </SidebarHeader>
    <GetStartedList contractor={contractor} organization={organization} />
  </SidebarContainer>
);

export default GetStartedSidebar;
